import { render } from "./addNewsDialog.vue?vue&type=template&id=37b2d7e4&scoped=true"
import script from "./addNewsDialog.vue?vue&type=script&lang=js"
export * from "./addNewsDialog.vue?vue&type=script&lang=js"

import "./addNewsDialog.vue?vue&type=style&index=0&id=37b2d7e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b2d7e4"]])

export default __exports__